module.exports = __webpack_public_path__ + "media/images/lb/022-c7fb7365f5dddce2b36ac5353b08c6ba.svg";